import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" {...props}><path d="M9.293 12.293a1 1 0 1 0 1.414 1.414l-1.414-1.414zM16 7l.707.707a1 1 0 0 0 0-1.414L16 7zM10.707.293a1 1 0 1 0-1.414 1.414L10.707.293zm0 13.414l6-6-1.414-1.414-6 6 1.414 1.414zm6-7.414l-6-6-1.414 1.414 6 6 1.414-1.414zM16 6H0v2h16V6z" /></svg>);